import { render } from "./PricingOne.vue?vue&type=template&id=bff8bd8c&scoped=true"
import script from "./PricingOne.vue?vue&type=script&lang=js"
export * from "./PricingOne.vue?vue&type=script&lang=js"

import "./PricingOne.vue?vue&type=style&index=0&id=bff8bd8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff8bd8c"]])

export default __exports__